import { captureMessage } from '@sentry/react';
import { Source } from 'generated/graphql';
import { SourceName, SourceNameWithNamespace } from 'v2/core/entities/fields';

export const SourceToEdgeSource: Record<SourceName, Source | undefined> = {
  INTERCOM: Source.Intercom,
  APPSTORE: Source.Appstore,
  PLAYSTORE: Source.Playstore,
  FRESHCHAT: Source.Freshchat,
  LIVECHAT: Source.Livechat,
  SLACK: Source.Slack,
  TWITTER: Source.Twitter,
  FILE_UPLOAD: Source.FileUpload,
  KUSTOMER: Source.Kustomer,
  NPS: Source.Nps,
  DISCOURSE: Source.Discourse,
  DELIGHTED: Source.Delighted,
  ZENDESK_SUPPORT: Source.ZendeskSupport,
  ZENDESK_CHAT: Source.ZendeskChat,
  STELLA_CONNECT: Source.StellaConnect,
  SURVEY_MONKEY: Source.SurveyMonkey,
  ZOHO_DESK: Source.ZohoDesk,
  FRONT: Source.Front,
  G2: Source.G2,
  FRESHDESK: Source.Freshdesk,
  TYPEFORM: Source.Typeform,
  GONG: Source.Gong,
  EMAIL: Source.Email,
  SALESFORCE: Source.Salesforce,
  DISCORD: Source.Discord,
  SNOWFLAKE: Source.Snowflake,
  REDDIT: Source.Reddit,
  GRAIN: Source.Grain,
  FACEBOOK_PAGES: Source.FacebookPages,
  QUALTRICS: Source.Qualtrics,
  AMAZON_CONNECT: Source.AmazonConnect,
  CHORUS: Source.Chorus,
  GOOGLE_MY_BUSINESS: Source.GoogleMyBusiness,
  GAINSIGHT: Source.Gainsight,
  SPRIG: Source.Sprig,
  // internal sources
  COMMON: undefined,
  ENTERPRET: undefined,
};

const getSourceWithNamespaceFromEdgeSource = (
  source?: Source,
  namespace?: string,
): SourceNameWithNamespace => {
  const sourceName = sourceFromEdgeSource(source);
  return { name: sourceName, namespace };
};

const sourceFromEdgeSource = (source?: Source): SourceName => {
  if (!source) {
    return 'COMMON';
  }

  switch (source) {
    case Source.Appstore:
      return 'APPSTORE';

    case Source.Playstore:
      return 'PLAYSTORE';

    case Source.Freshchat:
      return 'FRESHCHAT';

    case Source.Livechat:
      return 'LIVECHAT';

    case Source.Slack:
      return 'SLACK';

    case Source.Twitter:
      return 'TWITTER';

    case Source.Intercom:
      return 'INTERCOM';

    case Source.FileUpload:
      return 'FILE_UPLOAD';

    case Source.Kustomer:
      return 'KUSTOMER';

    case Source.Nps:
      return 'NPS';

    case Source.Discourse:
      return 'DISCOURSE';

    case Source.Delighted:
      return 'DELIGHTED';

    case Source.ZendeskSupport:
      return 'ZENDESK_SUPPORT';

    case Source.ZendeskChat:
      return 'ZENDESK_CHAT';

    case Source.StellaConnect:
      return 'STELLA_CONNECT';

    case Source.SurveyMonkey:
      return 'SURVEY_MONKEY';

    case Source.ZohoDesk:
      return 'ZOHO_DESK';

    case Source.Front:
      return 'FRONT';

    case Source.G2:
      return 'G2';

    case Source.Freshdesk:
      return 'FRESHDESK';

    case Source.Typeform:
      return 'TYPEFORM';

    case Source.Gong:
      return 'GONG';

    case Source.Email:
      return 'EMAIL';

    case Source.Salesforce:
      return 'SALESFORCE';

    case Source.Discord:
      return 'DISCORD';

    case Source.Snowflake:
      return 'SNOWFLAKE';

    case Source.Reddit:
      return 'REDDIT';

    case Source.Grain:
      return 'GRAIN';

    case Source.FacebookPages:
      return 'FACEBOOK_PAGES';

    case Source.Qualtrics:
      return 'QUALTRICS';

    case Source.AmazonConnect:
      return 'AMAZON_CONNECT';

    case Source.GoogleMyBusiness:
      return 'GOOGLE_MY_BUSINESS';

    case Source.Chorus:
      return 'CHORUS';

    case Source.Gainsight:
      return 'GAINSIGHT';

    case Source.Sprig:
      return 'SPRIG';

    default:
      captureMessage(`Unhandled source: ${source}`);
      return source as SourceName;
  }
};

const edgeSourceFromSource = (source: SourceName): Source => {
  const eSource = SourceToEdgeSource[source];
  if (!eSource) {
    throw Error(`unknown source ${source})`);
  }

  return eSource;
};

export {
  edgeSourceFromSource,
  getSourceWithNamespaceFromEdgeSource,
  sourceFromEdgeSource,
};
